<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<mat-dialog-content class="mat-dialog-content">
  <ckeditor #contentEditor [config]="editorConfig" [editor]="Editor" [data]=data (ready)="onEditorReady($event)" (change)="onChange($event)"></ckeditor>
  <!-- apparently, this can also be achieved by using [(ngModel)]="postData.content" debounce="300" -->
  <tag-editor [tagIn]="tag" (tagsUpdate)="updateTags($event)" [config]="config" [syncAtStart]="false"></tag-editor>
</mat-dialog-content>
<button (click)="loadLastUnsavedEdit()" [disabled]="noUnsavedEditTooltip()" matTooltip="{{ noUnsavedEditTooltip() }}">
  Load last unsaved edit
</button>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close *ngIf="!liveFeedback">Cancel</button>
  <button mat-button [mat-dialog-close]="true" (click)="addContent($event)">{{ addButtonLabel }}</button>
</mat-dialog-actions>

<!-- Copyright 2020 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->